module.exports = __webpack_public_path__ + "img/responsive hospitium-15.ccea58ed.jpg";